export { ExtendedTokenSpecSchema, type ExtendedTokenSpec, toDesignTokenSpec } from './schema.js';
export { validateExtendedTokens, calculateComplianceScore } from './validator.js';
